/* HL: products in the empty cart drawer.
   <hl-cart-recently-viewed data-mode="best-sellers|recently-viewed" data-url="...">
   best-sellers    fetches data-url as is (a collection sorted by best-selling,
                   rendered through sections/hl-cart-recently-viewed).
   recently-viewed appends the product ids the theme stores on product pages
                   (localStorage "beyours:recently-viewed") as a search query.
   Lives in its own asset because the drawer markup is injected with innerHTML,
   where inline scripts never run. Loaded from layout/theme.liquid. */
(function () {
  if (customElements.get('hl-cart-recently-viewed')) return;

  class HlCartRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      var url = this.dataset.url;

      if (this.dataset.mode !== 'best-sellers') {
        var ids = [];
        try {
          ids = JSON.parse(window.localStorage.getItem('beyours:recently-viewed') || '[]');
        } catch (e) {
          ids = [];
        }
        ids = ids.slice(0, 4);
        if (!ids.length) return;
        url += encodeURIComponent(ids.map(function (id) { return 'id:' + id; }).join(' OR '));
      }

      var el = this;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var results = doc.querySelector('hl-cart-recently-viewed-results');
          if (results && results.innerHTML.trim().length) el.innerHTML = results.innerHTML;
        })
        .catch(function () {});
    }
  }

  customElements.define('hl-cart-recently-viewed', HlCartRecentlyViewed);
})();
